(function () {
  function updateHeader() {
    var body = document.body;
    if (!body || !body.classList.contains('mk-home-page')) return;
    var root = document.documentElement;
    var main = document.getElementById('MainContent');
    var wrapper = document.querySelector('.page-wrapper');
    var offset = Math.max(window.scrollY || 0, root ? root.scrollTop : 0, body.scrollTop || 0, main ? main.scrollTop : 0, wrapper ? wrapper.scrollTop : 0);
    var scrolled = offset > 0;
    body.classList.toggle('mk-scrolled', scrolled);
    var header = document.getElementById('header-group');
    if (header) header.classList.toggle('mk-scrolled', scrolled);
  }
  window.addEventListener('scroll', updateHeader, { passive: true });
  document.addEventListener('scroll', updateHeader, { passive: true, capture: true });
  document.addEventListener('shopify:section:load', updateHeader);
  window.addEventListener('pageshow', updateHeader);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateHeader);
  else updateHeader();
})();
